// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedPapersSidebar-cls1_Gl-","cls2":"RelatedPapersSidebar-cls2_MqN RelatedPapersSidebar-cls1_Gl-"};